module.exports = __webpack_public_path__ + "img/banner-imgMob3x.png";